import * as React from "react";
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "./assets/transparentLogo.png";
import { SocialLinks } from "./Socials";

const pages = [
  { label: "Hours", href: "#hours" },
  { label: "Classes", href: "#classes" },
  { label: "Pricing", href: "#pricing" },
  { label: "Join", href: "#join" },
  { label: "Contact", href: "#contact" },
];

function HideAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [currentHash, setCurrentHash] = React.useState(() => window.location.hash);
  const menuDestination = React.useRef(null);
  const open = Boolean(anchorElNav);

  React.useEffect(() => {
    const updateHash = () => setCurrentHash(window.location.hash);
    window.addEventListener("hashchange", updateHash);
    return () => window.removeEventListener("hashchange", updateHash);
  }, []);

  const focusMenuDestination = () => {
    const destination = menuDestination.current;
    if (destination) {
      destination.focus({ preventScroll: true });
      if (destination.matches(".section-column")) {
        destination.scrollIntoView({ block: "start" });
      }
      menuDestination.current = null;
    }
  };

  return (
    <AppBar className="site-header" position="fixed" component="header">
      <Toolbar className="header-inner" disableGutters>
        <a className="brand" href="#home" aria-label="Positive NRG home">
          <img src={logo} alt="Positive NRG" width="188" height="48" />
        </a>
        <nav className="desktop-nav" aria-label="Main navigation">
          {pages.map(({ label, href }) => (
            <Button
              key={label}
              href={href}
              aria-current={currentHash === href ? "location" : undefined}
              variant={label === "Join" ? "contained" : "text"}
            >
              {label}
            </Button>
          ))}
        </nav>
        <div className="header-socials">
          <SocialLinks label="Header social links" />
        </div>
        <IconButton
          className="mobile-menu-button"
          id="navigation-button"
          aria-label="Open navigation menu"
          aria-controls={open ? "navigation-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open}
          onClick={(event) => {
            menuDestination.current = event.currentTarget;
            setAnchorElNav(event.currentTarget);
          }}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          id="navigation-menu"
          anchorEl={anchorElNav}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={open}
          onClose={() => setAnchorElNav(null)}
          disableRestoreFocus
          TransitionProps={{ onExited: focusMenuDestination }}
          MenuListProps={{ "aria-labelledby": "navigation-button" }}
        >
          {pages.map(({ label, href }) => (
            <MenuItem
              key={label}
              component="a"
              href={href}
              aria-current={currentHash === href ? "location" : undefined}
              onClick={() => {
                menuDestination.current = document.getElementById(href.slice(1));
                setAnchorElNav(null);
              }}
              sx={{ minWidth: 200 }}
            >
              {label}
            </MenuItem>
          ))}
        </Menu>
      </Toolbar>
    </AppBar>
  );
}

export default HideAppBar;
